import { IDropdownOption } from "@fluentui/react";

const attachmentWarning: string = 'CompleteObservation.AttachmentAsEvidence';

export const includeAttachmentOptions: IDropdownOption[] = [
    { key: 1, text: 'ConfirmationDialog.Yes', data: attachmentWarning },
    { key: 0, text: 'ConfirmationDialog.No', data: attachmentWarning }
]